import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useGetUserByIdQuery } from 'store/auth/auth.api'
import { setUser } from 'store/auth/auth.slice'
import { getUserId } from 'utils/common'

/**
 * Redux only received the full user profile on the Settings page. After login or
 * refresh, `auth.user` stayed at the empty mock so the top bar showed "Transpots".
 */
export function AuthUserSync() {
  const dispatch = useDispatch()
  const userId = getUserId()
  const hasToken =
    typeof window !== 'undefined' && !!window.sessionStorage.getItem('accessToken')

  const { data: user, isSuccess } = useGetUserByIdQuery(
    { userId },
    { skip: !userId || !hasToken }
  )

  useEffect(() => {
    if (!isSuccess || !user) return
    dispatch(setUser({ user }))
  }, [dispatch, isSuccess, user])

  return null
}
